<div class="rail-host" (click)="closeIfBackdrop($event)">
    <nav class="rail" id="main-nav" aria-label="Main">
        <a *ngFor="let item of items; trackBy: trackRoute" class="rail-item" [routerLink]="item.route"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.exact }" [title]="item.label">
            <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
            <span class="rail-label">{{ item.label }}</span>
        </a>
    </nav>
</div>

<main class="content">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    <router-outlet *ngIf="!isIframe"></router-outlet>
    <side-bar></side-bar>
</main>
